import { useState, useEffect } from 'react';
import { Format } from '../types';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../config/firebase';
import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  query, 
  where, 
  onSnapshot,
  orderBy 
} from 'firebase/firestore';

export const useFormats = () => {
  const [formats, setFormats] = useState<Format[]>([]);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      setFormats([]);
      return;
    }

    const q = query(
      collection(db, 'formats'),
      where('userId', '==', user.id),
      orderBy('name')
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const formatsData: Format[] = [];
      querySnapshot.forEach((doc) => {
        formatsData.push({ id: doc.id, ...doc.data() } as Format);
      });
      setFormats(formatsData);
    });

    return () => unsubscribe();
  }, [user]);


  const addFormat = async (name: string) => {
    if (!user) return;

    try {
      await addDoc(collection(db, 'formats'), {
        name: name.trim(),
        userId: user.id
      });
    } catch (error) {
      console.error('Error adding format:', error);
      throw error;
    }
  };

  const updateFormat = async (formatId: string, name: string) => {
    try {
      await updateDoc(doc(db, 'formats', formatId), {
        name: name.trim()
      });
    } catch (error) {
      console.error('Error updating format:', error);
      throw error;
    }
  };

  const deleteFormat = async (formatId: string) => {
    try {
      await deleteDoc(doc(db, 'formats', formatId));
    } catch (error) {
      console.error('Error deleting format:', error);
      throw error;
    }
  };

  return {
    formats,
    addFormat,
    updateFormat,
    deleteFormat
  };
};